import axios from "axios";

const getAuthHeader = () => {
    const token = sessionStorage.getItem('token');
    const header = {
        headers: { 
            Authorization: "Bearer " + token
     }
    };
    return header;
}

export const getMasterCardUrl= async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/api/mastercard/get_session`
    return await axios.post(url, body,
     getAuthHeader()).then((res)=>{
      return res.data
    })
  }

  export const getStudyMaterialMasterCardApi= async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/api/studymaterial/mastercard/session`
    return await axios.post(url, body,
     getAuthHeader()).then((res)=>{
      return res.data
    })
  }